import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { autoUnsubWith, Utility } from '@shared/services/utility.abstract';
import { ToastService } from '@shared/services/toast.service';
import {
  BreadcrumbItem,
  CompanyService,
} from '@shared/services/company.service';
import {
  EQUIPMENT_INFORMATION_LABEL,
  SOPT_INCREASE_ACH_PAYMENT_SUCCESS_MSG,
  SPOT_INCEASE_DECREASE_SUCCSESS_MSG,
  SPOT_INCREASE_PAYMENT_FAILED_MSG,
  SPOT_TYPE_LABEL,
  USER_ROLES,
} from '@shared/constant/shared.constant';
import { CommonMenuService } from '@shared/services/common-util.service';
import { PaymentMode, PaymentStatusForMessage } from '@core/models/api-response.model';
import { SharedInvoicePopupComponent } from '@shared/components/shared-invoice-popup/shared-invoice-popup.component';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { SuperAdminService } from '@core/services/super-admin.service';
import { SpotCountUpdateSuccessModalComponent } from '@shared/components/spot-count-update-success-modal/spot-count-update-success-modal.component';
import { CommonFunctions } from '@shared/common-functions';
import { BookingService } from '@core/services/booking.service';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';
import { DateTime } from 'luxon';
@Component({
  selector: 'app-group-booking-details',
  templateUrl: './group-booking-details.component.html',
  styleUrls: ['./group-booking-details.component.scss'],
})
export class GroupBookingDetailsComponent implements OnInit{
  readonly destroyRef = inject(DestroyRef);
  id: string = '';
  bookingDetail: any;
  paymentMode: any = PaymentMode;
  slotsHistory: any[] = [];
  invoiceNumber: string = '';
  companyId: any;
  role: string = '';
  items;
  driverId: any;
  comeFromDriverList: boolean = false;
  equipmentMsg: string = EQUIPMENT_INFORMATION_LABEL;
  spotTypeMsg: string = SPOT_TYPE_LABEL;
  emptyImageHolder: string = 'assets/images/emptyHolder.png';
  paymentStatusForMessage = PaymentStatusForMessage;
  comeFromGroupOperatorList: boolean = false;
  userRoles = USER_ROLES;
  isSmallScreen: boolean = false;
  cancellationReason = [
    { reason: 'Duplicate', value: '1' },
    { reason: 'Request by the customer', value: '2' },
  ];
  constructor(
    private readonly service: BookingService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly toastService: ToastService,
    private readonly companyService: CompanyService,
    private readonly _location: Location,
    private readonly superAdminService: SuperAdminService,
    private readonly commonMenuService: CommonMenuService,
    private readonly dialogControlService: DialogControlService,
    private readonly encryptStorage: EncryptionStorageService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.id = params['id'];
      this.comeFromDriverList = params['driverList']
        ? JSON.parse(params['driverList'])
        : false;
      this.comeFromGroupOperatorList = params['groupOparatorList'] ? JSON.parse(params['groupOparatorList']) : false
      const isSpotUpdateParam = params['isSpotUpdate'];
      const paymentMethodParam = params['paymentMethod'];

      if (isSpotUpdateParam !== undefined && paymentMethodParam !== undefined) {
        const isSpotUpdate = JSON.parse(isSpotUpdateParam);
        const paymentMethod = JSON.parse(paymentMethodParam);
        this.checkStripePaymentStatus(isSpotUpdate, paymentMethod);
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {
            paymentMethod: null,
            isSpotUpdate: null
          },
          queryParamsHandling: 'merge',
          replaceUrl: true
        });
      }

    });
    this.companyId = this.encryptStorage.getItem('companyId');
    this.role = this.encryptStorage.getItem('roleName');
    const state = history.state;
    const breadcrumbObj: BreadcrumbItem[] = [
      ...(this.comeFromGroupOperatorList ? [{ title: 'User Database', url: 'super-admin/user-database-list' }] : []),
      {
        title: this.comeFromDriverList? 'Parker Information' : this.comeFromGroupOperatorList ? ' Group Operator Information' : 'Bookings',
        url: this.comeFromDriverList?  `/super-admin/driver-info?id=${state.userId}&tab=0` : this.comeFromGroupOperatorList
          ? `/super-admin/group-operator-info?Id=${state.userId}&tab=0` : '/super-admin/group-booking-list/' + this.companyId,
      },
      {
        title: 'Booking Details',
      },
    ];
    this.companyService.setAdminHeaders('0', breadcrumbObj);
    this.superAdminService.popupClosed$.subscribe(refresh => {
      if (refresh) {
        this.getGroupBookingDetailById(this.id);
      }
    });
    this.getGroupBookingDetailById(this.id);
  }

  backClicked() {
    if (document.referrer.includes('api/v1/BookingSlot/IncreaseGroupBookingSpotSuccessPayment')) {
      this.navigateToReservation();
    }
    this._location.back();
  }

  showData() {
    const actionMap = {
      viewInvoice: () => {
        this.viewInvoice();
      },
    };

    const config = [
      {
        label: '',
        icon: '',
      },
      {
        label: 'Share Invoice',
        icon: 'common-icon share-invoice',
        command: () => {
          this.dialogControlService.openDialog(SharedInvoicePopupComponent, {
            styleClass: 'shareinvoice-model',
            data: {
              bookingId: this.bookingDetail.id,
              email: this.bookingDetail?.driverEmail,
              mobileNumber: this.bookingDetail?.phoneNumber ? this.bookingDetail?.countryCode + ' ' + this.bookingDetail?.phoneNumber : null,
              isBookingExist: true,
            },
          });
        },
      },
      {
        label: 'View Invoice',
        icon: 'common-icon view-profile',
        command: actionMap.viewInvoice,
      },
    ];

    this.items = this.commonMenuService.commonShowData(config);
  }

  getReasonText(value: string): string {
    const found = this.cancellationReason.find(r => r.value === value);
    return found ? found.reason : '';
  }

  setTooltipDataForSlotUpdate(item) {
    if (!item) return '';
    return `<div class="tooltip-heading"><h5>Add-on</h5><p>On ${item?.updateDate}</p></div><div class="tooltip-inner-text"><p><span>Spot Count</span><span>${item.spotCount}</span></p><p><span>Amount</span> <span>$${item.amount}</span></p><p><span>Taxes</span> <span>$${item.taxAndFees}</span></p><p><span>Fees</span> <span>$${item.transactionFees}</span></p></div><div class="dotes-border"><p><span>Total add-on</span> <span>$${item.total}</span></p></div>`;
  }
    getScreenSize(event: any) {
    this.isSmallScreen = event.isSmallScreen
  };

  getGroupBookingDetailById(Id: string) {
    this.service.getGroupBookingDetailById(Id)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response: any) => {
        this.bookingDetail = response;
        if (this.bookingDetail?.accessCode == null) {
          this.bookingDetail.accessCode = ['-', '-', '-', '-', '-', '-'];
        }
        this.invoiceNumber = response.invoiceNumber;
        this.slotsHistory = response.bookingSlotHistoryOutput;
      }
    });
  }

  getChechInOutDetails() {
    this.service.getCheckInOutDetails(this.id)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: () => {
        
        this.toastService.showToastMessage(
          'success',
          'Success',
          'Access code shared successfully'
        );
      }
    });
  }

  getAssignedSpotsDisplay(detail: any): string {
    const value =
      detail?.assignedSpots ??
      detail?.slotNames ??
      detail?.slotName ??
      detail?.parkingSlot ??
      detail?.parkingSlots;

    return this.formatAssignedSpots(value);
  }

  private formatAssignedSpots(value: unknown): string {
    if (!value) {
      return '-';
    }

    const normalizeSpot = (spot: string) =>
      spot === 'Any' ? 'Park Anywhere' : spot;

    if (Array.isArray(value)) {
      const spots = value
        .map((item) =>
          typeof item === 'string' ? item : (item?.slotName as string)
        )
        .filter((spot) => !!spot)
        .map((spot) => normalizeSpot(spot));

      return spots.length ? spots.join(', ') : '-';
    }

    if (typeof value === 'string') {
      const spots = value
        .split(',')
        .map((spot) => spot.trim())
        .filter((spot) => !!spot)
        .map((spot) => normalizeSpot(spot));

      return spots.length ? spots.join(', ') : '-';
    }

    return '-';
  }

  navigateToReservation() {
    const companyIdParam =
      this.role === this.userRoles.SUPER_ADMIN ? `/${this.companyId}` : '';
    const route =
      this.role === this.userRoles.SUPER_ADMIN
        ? `super-admin/bookings${companyIdParam}`
        : 'manager/booking';
    const driverListRouter =
      this.role === this.userRoles.SUPER_ADMIN
        ? '/super-admin/driver-list'
        : 'manager/booking';

    if (this.comeFromDriverList === true) { 
      this.router.navigate([driverListRouter]);
    } else {
      this.router.navigate([route]);
    }
  }

  getTimeZoneAbbreviation(timeZone: string): string {
    return CommonFunctions.getTimeZoneAbbreviation(timeZone);
  }

  viewInvoice() {
    
    const req = {
      bookingId: this.id,
      timeZone: Utility.getLocalTimeZone(),
    };
    this.service.viewInvoice(req)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response) => {
        
        window.open(response as string, '_blank');
      },
      error: (error) => {
        this.toastService.showToastMessage(
          'error',
          'Error',
          error.error.message
        );
        
      },
    });
  }
checkStripePaymentStatus(isSpotUpdate:boolean,paymentMethod:number) {
  let heading = '' ;
  let bodyText = SPOT_INCEASE_DECREASE_SUCCSESS_MSG;

  if (!isSpotUpdate) {
    heading = 'Payment Failed';
    bodyText = SPOT_INCREASE_PAYMENT_FAILED_MSG;
  }

  // For spot updates
  if (paymentMethod === 2 && isSpotUpdate) {
    heading = 'Payment Initiated';
    bodyText = SOPT_INCREASE_ACH_PAYMENT_SUCCESS_MSG;
  }

  this.dialogControlService.openDialog(SpotCountUpdateSuccessModalComponent, {
    styleClass: 'check-stripe-payment',
    data: {
      heading:heading,
      bodyText:bodyText,
      isSpotUpdate: isSpotUpdate,
      bookingId:this.id
    },
  });
}

  get paymentStatusCheck() {
    return (
      this.bookingDetail?.paymentStatus === PaymentStatusForMessage.Pending ||
      this.bookingDetail?.paymentStatus === PaymentStatusForMessage.Cancelled
    );
  }

get isBookingCancelledCheck(): boolean {
    return !(
      (this.bookingDetail?.bookingPaymentMode === this.paymentMode.Offline && this.bookingDetail?.paymentStatus === this.paymentStatusForMessage.PartialCancel) ||
      (this.bookingDetail?.bookingPaymentMode === this.paymentMode.Offline && this.bookingDetail?.paymentStatus === this.paymentStatusForMessage.Completed && this.bookingDetail?.isCancelled) ||
      (this.bookingDetail?.paymentStatus === this.paymentStatusForMessage.Cancelled && this.bookingDetail?.isCancelled)
    );
  }
  get refundAmountCheck(): boolean {
    return !(this.bookingDetail?.paymentStatus === this.paymentStatusForMessage.Cancelled && this.bookingDetail?.isCancelled && this.bookingDetail?.bookingStatus.label === 'Cancelled') || this.bookingDetail?.refundableAmount > 0;
  }

  getSelectedRating(parkingExperinceRating: number) {
    return  CommonFunctions.getSelectedRating(parkingExperinceRating);
  }

  get bookingCancelWithRefundCheck(): boolean {
    return this.bookingDetail?.isCancelled && this.bookingDetail?.refundableAmount > 0;
  }

  getFormattedPaymentDate(): string {
    if (!this.bookingDetail?.billingDate) {
      return this.bookingDetail?.arrivalTime || '-';
    }
    const billingDt = DateTime.fromISO(this.bookingDetail.billingDate, { setZone: true });
    const timestamp = Number(this.bookingDetail.arrivalTimeStamp);
    if (!timestamp) {
      return billingDt.toFormat('MMM dd, yyyy - hh:mm a');
    }
    const arrivalDt = DateTime.fromSeconds(timestamp, { zone: billingDt.zone });
    const combined = billingDt.set({
      hour: arrivalDt.hour,
      minute: arrivalDt.minute,
      second: arrivalDt.second,
    });
    return combined.toFormat('MMM dd, yyyy - hh:mm a');
  }

}
